export interface UserItem {
  id: string;
  name: string;
  email: string;
  role: string;
  createdAt: string;
  updatedAt: string;
  workspaceIds?: string[];
}

export const ROLES = ['admin', 'manager', 'coach', 'scout', 'medical', 'player'] as const;

export const roleBadgeColors: Record<string, string> = {
  admin: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300',
  manager: 'bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300',
  coach: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300',
  scout: 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-300',
  medical: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
  player: 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300',
};

export const inputClasses = 'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm';
export const labelClasses = 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1';
